module.exports = __webpack_public_path__ + "img/icon_advantage.941b2be6.png";